import axios from 'axios';
import {AUTH_BASE_URL, DATA_BASE_URL} from '../config';

export const authBaseUrl = AUTH_BASE_URL;
export const dataBaseUrl = DATA_BASE_URL;

const isOffline = async () => {
    const healthyAuth = await urlHealth(authBaseUrl, '_health');
    const healthyData = await urlHealth(dataBaseUrl, '_health');
    return !(healthyAuth && healthyData);
};

const urlHealth = async (baseURL, url) => {
    let error = null;
    await axios.request({baseURL, url}).catch((e) => error = e);
    return (error) ? error.response : true;
};

export const checkIsOffline = async () => {
    return await isOffline();
};